export const CHANGES = 'admin/changes/all'
export const ADD_CHANGE = 'admin/changes/add'
export const DELETE_CHANGE = 'admin/changes/delete'
